import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { showEndClient, editEndClient, createEndClient } from '../../controllers/api_end_clients'; // Importa el servicio
import { getTypeTaxpayer } from '../../controllers/api_type_taxpayer'; // Importa el servicio
import { useNavigate } from "react-router-dom"; // Para la redirección
import { decryptText } from '../../controllers/api'; // Importa el servicio para encriptar/desencriptar parametros
import { useLocation } from "react-router-dom"; // Para la obtener el parametro de la url
import { toast, ToastContainer } from "react-toastify"; // Importamos las funciones necesarias
import "react-toastify/dist/ReactToastify.css"; // Importar el CSS de las notificaciones
import $ from "jquery";
import {
  validateFormatEmail,
  validateFormatPhone,
  contarDigitosDocumento,
  esFirmaPersonal,
  mapearCat7,
  filtrarTiposCliente,
  validarLongitudCat7,
  validarCoherenciaRifCat7,
  validarFormatoRifCat7,
} from "../../utils/formatters";
import { preventEnterSubmit, FORM_FOOTER_CONTAINER, FORM_BTN_CANCEL, FORM_BTN_SUBMIT } from "../../utils/formHelpers";
import { getCatalogoPublico } from '../../controllers/apiSeniat'; // Cat 7 (público)

// =====================================================================
// (Firma personal / Cat 7, 2026-07-03; ítem 28, 2026-08-02)
// El COMPORTAMIENTO del campo R.I.F. lo gobierna `es_rif` del TIPO de
// identificación elegido (Catálogo 7), NO un radio "Tipo de cliente"
// (eliminado en el ítem 28-iv: el backend DERIVA es_rif de la fila Cat 7 —
// client_routes.py:351-357 / servicios_compartidos.derivar_es_rif).
//
// Los helpers ESPEJO del backend (conteo de dígitos, longitud por tipo,
// coherencia de la letra, formato del RIF) viven en utils/formatters.js y los
// comparten este formulario y el de Empresa (FormClients) — una sola
// implementación, un solo sitio que auditar.
// REGLA DURA: NUNCA se manipula/rellena/recorta el NÚMERO; solo se antepone
// la letra del tipo y se cuenta la parte numérica para aceptar o rechazar.
// =====================================================================

function FormEndClients() {
  const navigate = useNavigate(); // Hook para redirección
  // Obtener los query parameters con `useLocation`
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const clientId = queryParams.get("id"); // Obtener el ID de la URL
  const [client, setClient] = useState(null);
  const [typeTaxpayer, setTypeTaxpayer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [errors, setErrors] = useState({}); // Estado para errores de validación
  // (Firma personal / Cat 7, 2026-07-03) Opciones del Catálogo 7 (tipo de
  // identificación) con las DOS filas 'V' distinguibles. Cada opción:
  // { id, codigo, descripcion, es_rif, label }. `id` puede ser null si el
  // catálogo llegó degradado (fallback normativo): en ese caso se envía solo la
  // letra y el backend resuelve la fila 'V' por longitud (camino legacy).
  const [tiposIdentificacion, setTiposIdentificacion] = useState([]);
  // (ítem 28-iii) Aviso VISIBLE de degradación del Catálogo 7. Nunca se degrada
  // en silencio: si el catálogo no cargó (o llegó sin id/es_rif) el usuario
  // debe saber que su elección puede no persistirse.
  const [catalogoAviso, setCatalogoAviso] = useState(null);

  // Simulando la carga de datos del client por el ID
  useEffect(() => {
    const fetchClient = async () => {
      try {
        const datattp = await getTypeTaxpayer();
        //console.log('datattp: ', datattp);
        setTypeTaxpayer(datattp);

        // (ítem 28-iii, 2026-08-02) Catálogo 7 desde el endpoint PÚBLICO
        // GET /api/catalogos/tipo-identificacion. Antes se pedía a
        // /api/seniat/catalogos, que es admin/auditor-only: TODO operador
        // recibía 403 y el formulario caía al fallback (id null) SIEMPRE, de
        // modo que `tipo_identificacion_id` nunca se persistía. El endpoint
        // público publica `id` y `es_rif` por fila (seniat_routes.py:1295-1303).
        // (2026-08-03, ronda 2 / T1) `filtrarTiposCliente` YA NO retira la fila
        // 'C' (Comunal): por decisión del usuario, C debe poder usarse en
        // clientes finales y en empresas, y `utils.validar_rif` la admite
        // (patrón `^[VEJGPC]-\d{8}-\d$`, utils.py:351). El filtro se mantiene
        // en la llamada porque su lista de exclusión (hoy vacía) es el punto
        // único donde volver a excluir una fila si hiciera falta.
        try {
          const cat = await getCatalogoPublico('tipo-identificacion');
          const { opciones, aviso } = mapearCat7(cat);
          setTiposIdentificacion(filtrarTiposCliente(opciones));
          setCatalogoAviso(aviso);
          if (aviso) toast.warn(aviso, { autoClose: 8000 });
        } catch (e) {
          // No bloqueante, pero NUNCA silencioso: se avisa al usuario.
          console.warn('No se pudo cargar el Catálogo 7 (tipo de identificación).', e);
          const { opciones, aviso } = mapearCat7(null);
          setTiposIdentificacion(filtrarTiposCliente(opciones));
          setCatalogoAviso(aviso);
          toast.warn(aviso, { autoClose: 8000 });
        }

        if (clientId != null){
          const data = await showEndClient(decryptText(clientId)); // Llamamos a showClient con el ID
          //console.log('data: ', data);
          setClient(data); // Guardamos los datos del client en el estado
        }else{
          setClient({
            id: "#",
            rif: "",
            nombre: "",
            telefono: "",
            email: "",
            direccion: "",
            activo: true,
            // (ítem 28-iv) `es_rif` YA NO se envía desde el formulario: el
            // backend lo DERIVA de la fila del Catálogo 7 elegida
            // (client_routes.py:351-357). Tener dos fuentes garantizaba que se
            // contradijeran.
            //tipo_contribuyente_id: 1,
            // (Firma personal / Cat 7): id de la fila Cat 7 elegida (FK). null =
            // sin elección explícita; el backend resuelve la 'V' por longitud.
            tipo_identificacion_id: null,
          })
        }
      } catch (err) {
        setError('Error al cargar el cliente');
      } finally {
        setLoading(false); // Indicamos que la carga ha finalizado
      }
    };
    fetchClient();
  }, [clientId]); // Recarga si el `clientId` cambia

  // (Firma personal / Cat 7, 2026-07-03) Preselección del índice del selector
  // al editar: se prioriza la fila Cat 7 ya guardada (nested `tipo_identificacion`
  // con id/codigo/descripcion). Si no hay id (legacy), se resuelve por letra +
  // longitud (misma lógica que el backend). Sólo corre una vez cuando ya hay
  // catálogo y cliente y aún no se ha fijado el índice.
  useEffect(() => {
    if (!client || tiposIdentificacion.length === 0) return;
    if (client._tipoIdentIdx !== undefined && client._tipoIdentIdx !== null) return;

    let idx = null;
    const nested = client.tipo_identificacion; // {id, codigo, descripcion} o undefined
    if (nested && nested.id != null) {
      idx = tiposIdentificacion.findIndex((t) => t.id != null && Number(t.id) === Number(nested.id));
    }
    if ((idx == null || idx < 0) && client.tipo_identificacion_id != null) {
      idx = tiposIdentificacion.findIndex(
        (t) => t.id != null && Number(t.id) === Number(client.tipo_identificacion_id)
      );
    }
    // Fallback legacy: resolver por letra + longitud (como el backend).
    if ((idx == null || idx < 0)) {
      const letra = String(client.tipo_documento_identidad || '').toUpperCase();
      if (letra === 'V') {
        const n = contarDigitosDocumento(
          client.numero_documento != null ? client.numero_documento : client.rif
        );
        const quiereFirma = (n === 9);
        idx = tiposIdentificacion.findIndex(
          (t) => String(t.codigo).toUpperCase() === 'V' && esFirmaPersonal(t.descripcion) === quiereFirma
        );
      } else if (letra) {
        idx = tiposIdentificacion.findIndex((t) => String(t.codigo).toUpperCase() === letra);
      }
    }
    if (idx != null && idx >= 0) {
      setClient((prev) => ({ ...prev, _tipoIdentIdx: idx }));
    }
  }, [client, tiposIdentificacion]);

  if (loading) return <div>Cargando...</div>;
  if (error) return <div>{error}</div>;

  // (Firma personal / Cat 7, 2026-07-03) Devuelve la opción del Catálogo 7
  // actualmente seleccionada, según el índice UI `_tipoIdentIdx`. null si el
  // usuario no ha elegido una fila explícita.
  const getTipoIdentSeleccionado = () => {
    const idx = client && client._tipoIdentIdx;
    if (idx === undefined || idx === null || idx === '') return null;
    return tiposIdentificacion[Number(idx)] || null;
  };

  // (ítem 28-ii) `es_rif` EFECTIVO: sale del TIPO seleccionado (Catálogo 7),
  // igual que en el backend. Si aún no hay tipo elegido se deduce del propio
  // valor escrito (empieza por letra = formato RIF), que es lo único disponible.
  const esRifEfectivo = () => {
    const tipoSel = getTipoIdentSeleccionado();
    if (tipoSel) return !!tipoSel.es_rif;
    const v = (client && client.rif) ? String(client.rif).trim().toUpperCase() : '';
    return /^[A-Z]/.test(v);
  };

  // (Firma personal / Cat 7) Calcula el `numero_documento` EXACTAMENTE como lo
  // hace handleSubmit, para que validate() cuente los mismos dígitos que enviará
  // el backend. REGLA DURA: no rellena ni recorta; sólo deriva la parte numérica.
  const calcularNumeroDocumento = () => {
    if (!client || !client.rif) return client && client.numero_documento ? client.numero_documento : '';
    if (esRifEfectivo()) {
      // Formato RIF: quitar guiones y la letra prefijo -> parte numérica + dígito control.
      const sinGuiones = client.rif.toString().replaceAll('-', '');
      return sinGuiones.substr(1, sinGuiones.length);
    }
    // Cédula (es_rif=false): el número se guarda TAL CUAL.
    return client.rif;
  };

  // Validación de campos requeridos
  const validate = () => {
    const newErrors = {};
    var errorToast = [];
    if (!client.rif){
      newErrors.rif = "R.I.F. es obligatorio";
      errorToast.push("- R.I.F. es obligatorio");
    }
    // (ítem 28-ii) FORMATO del R.I.F. según `es_rif` del TIPO elegido — espejo
    // de client_routes.py:359-370: es_rif=true -> utils.validar_rif
    // (^[VEJGPC]-\d{8}-\d$); es_rif=false -> solo dígitos (6-8 por longitud).
    // Sin tipo elegido se conserva la regla histórica (validateFormatRif).
    if (client.rif){
      const _msgFormato = validarFormatoRifCat7(getTipoIdentSeleccionado(), client.rif);
      if (_msgFormato){
        newErrors.rif = _msgFormato;
        errorToast.push(`- ${_msgFormato}`);
      }
    }
    if (!client.nombre){
      newErrors.nombre = "Nombre es obligatorio";
      errorToast.push("- Nombre es obligatorio");
    }
    if (!client.denominacion_comercial){
      newErrors.denominacion_comercial = "Denominación comercial es obligatorio";
      errorToast.push("- Denominación comercial es obligatorio");
    }
    if (!client.telefono){
      newErrors.telefono = "Teléfono es obligatorio";
      errorToast.push("- Teléfono es obligatorio");
    }
    if (client.telefono){
      if (!validateFormatPhone(client.telefono)){
        newErrors.telefono = "Teléfono no presenta un formato válido";
        errorToast.push("- Teléfono no presenta un formato válido");
      }
    }
    if (!client.email){
      newErrors.email = "Correo electrónico es obligatorio";
      errorToast.push("- Correo electrónico es obligatorio");
    }
    if (client.email){
      if (!validateFormatEmail(client.email)){
        newErrors.email = "Correo electrónico no presenta un formato válido";
        errorToast.push("- Correo electrónico no presenta un formato válido");
      }
    }
    if (!client.direccion){
      newErrors.direccion = "Dirección es obligatoria";
      errorToast.push("- Dirección es obligatoria");
    }
    if (!client.region || client.region == '#'){
      newErrors.region = "Región es obligatoria";
      errorToast.push("- Región es obligatoria");
    }
    if (!client.estado || client.estado == '#'){
      newErrors.estado = "Estado es obligatoria";
      errorToast.push("- Estado es obligatoria");
    }
    if (!client.zona){
      newErrors.zona = "Zona es obligatoria";
      errorToast.push("- Zona es obligatoria");
    }
    if (!client.tipo_contribuyente_id || client.tipo_contribuyente_id == '#'){
      newErrors.tipo_contribuyente_id = "Tipo de contribuyente es obligatoria";
      errorToast.push("- Tipo de contribuyente es obligatoria");
    }

    // --- (V_IDNUM / Cat 7, 2026-07-04) validate() ESPEJO del backend ---
    // Regla del proyecto (V_IDNUM.md): replicar la validación de longitud del
    // backend (validar_tipo_identificacion). SOLO valida la longitud; NUNCA
    // manipula el valor que el usuario escribió (el dato se envía tal cual).
    //   V Persona Natural          -> 6 a 8 dígitos.
    //   V Firma personal / J/E/G/C -> exactamente 9 dígitos.
    //   P (Pasaporte)              -> ALFANUMÉRICO, longitud libre (EXCEPCIÓN;
    //                                 no se cuenta longitud de dígitos).
    // Mismatch => mensaje literal exigido por SENIAT/cliente.
    const tipoSel = getTipoIdentSeleccionado();
    if (tipoSel) {
      // (1) LONGITUD — espejo de servicios_compartidos.validar_tipo_identificacion
      //     (servicios_compartidos.py:283-349). Mensaje LITERAL de SENIAT.
      const msgLongitud = validarLongitudCat7(tipoSel, calcularNumeroDocumento());
      if (msgLongitud) {
        newErrors.tipo_identificacion_id = msgLongitud;
        errorToast.push(`- ${msgLongitud}`);
      }
      // (2) COHERENCIA de la letra — espejo del bloque (3) de
      //     validar_tipo_identificacion_empresa (servicios_compartidos.py:403-421),
      //     que es la regla que el ítem 28 pide replicar también para clientes:
      //     es_rif=true -> la 1ª letra del R.I.F. debe ser la del tipo;
      //     es_rif=false -> el número no lleva letra.
      const msgCoherencia = validarCoherenciaRifCat7(tipoSel, client.rif);
      if (msgCoherencia && !newErrors.rif) {
        newErrors.rif = msgCoherencia;
        errorToast.push(`- ${msgCoherencia}`);
      }
    }
    // -----------------------------------------------------------------------

    setErrors(newErrors);
    if (errorToast.length > 0){
      toast.error(<div>
        {errorToast.map(item => (
            <span className="text-start">{item}<br/></span>
          ))}
      </div>)
      setButtonDisabled(false);
    }
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonDisabled(true); // Iniciar carga (deshabilitar botón)
    if (!validate()) return;
    // Aquí enviarías los datos de nuevo al backend para actualizar al client
    //console.log("Client:", client);
    try {
      var data;
      var message = '';
      // (Firma personal / Cat 7, 2026-07-03) Opción del Catálogo 7 elegida por el
      // usuario (o null). Si tiene `id`, se envía `tipo_identificacion_id` (FK) y
      // se fuerza la letra elegida en `tipo_documento_identidad`. Si no tiene id
      // (fallback degradado), se envía sólo la letra y el backend resuelve la
      // fila 'V' por longitud. REGLA DURA: numero_documento se envía TAL CUAL.
      const tipoSel = getTipoIdentSeleccionado();
      // (higiene P3 / ítem 28-iii) Se trabaja sobre una COPIA: hasta ahora
      // handleSubmit MUTABA el estado `client` (delete/asignaciones directas),
      // de modo que un submit fallido dejaba el formulario alterado.
      const payload = { ...client };
      // `_tipoIdentIdx` es UI-only (índice del selector); NO viaja al backend.
      delete payload._tipoIdentIdx;
      // (ítem 28-iv) `es_rif` NO se envía: lo DERIVA el backend de la fila Cat 7.
      delete payload.es_rif;
      // Objeto anidado de solo-lectura del GET: no es parte del contrato de escritura.
      delete payload.tipo_identificacion;

      const _esRif = esRifEfectivo();
      if (_esRif){
        payload.tipo_documento_identidad = String(payload.rif || '').substr(0, 1);
        const _sinGuiones = String(payload.rif || '').replaceAll('-','');
        payload.numero_documento = _sinGuiones.substr(1, _sinGuiones.length);
      }else{
        payload.tipo_documento_identidad = "V";
        payload.numero_documento = payload.rif;
      }
      // Cat 7: la elección explícita del usuario manda sobre lo derivado.
      if (tipoSel) {
        payload.tipo_documento_identidad = tipoSel.codigo;
        payload.tipo_identificacion_id = tipoSel.id != null ? tipoSel.id : null;
      }

      if (client.id == '#'){
        delete payload.id;
        data = await createEndClient(payload);
        message = '!Creación de cliente realizada correctamente!';
      }else{
        data = await editEndClient(decryptText(clientId), payload); // Llamamos a editClient con el ID
        message = '!Actualización de cliente realizada correctamente!';
      }
      //console.log('editClient-data: ', data);
      setClient(data); // Guardamos los datos del client en el estado
      // Mostrar una notificación de éxito
      toast.success(message, {
        onClose: () => {
          // Espera a que la notificación se cierre para redirigir
          setTimeout(() => {
            navigate("/clients");  // Redirige a la lista de clientes
          }, 2000); // El tiempo debe ser el mismo o ligeramente mayor que la duración de la notificación
        },
      });
    } catch (err) {
      // (2026-08-02) Mostrar el ERROR REAL del backend (mismo patrón que
      // FormClients.js:389-398). Antes se mostraba un genérico "Error al
      // actualizar el cliente" que ocultaba el motivo exacto del 400 (tipo de
      // identificación incoherente, RIF duplicado, formato…) y encima
      // setError() destruía el formulario con los datos ya cargados.
      const backendMsg =
        err?.response?.data?.error ||
        err?.response?.data?.detalle ||
        err?.response?.data?.mensaje ||
        err?.response?.data?.message ||
        (Array.isArray(err?.response?.data)
          ? err.response.data.map((e) => e.error || e.message || JSON.stringify(e)).join("\n")
          : null) ||
        err?.message ||
        "No se pudo guardar el cliente. Intente nuevamente.";
      toast.error(backendMsg, { autoClose: 6000, style: { whiteSpace: "pre-line" } });
    } finally {
      setLoading(false); // Indicamos que la carga ha finalizado
      setButtonDisabled(false); // Re-habilitar el botón para reintentar
    }
  };

  const redirectToList = () => {
    navigate(`/clients`);
  };

  // (ítem 28-ii, 2026-08-02) Conformación del campo R.I.F. GOBERNADA POR EL
  // TIPO de identificación (Catálogo 7), no por el radio "Tipo de cliente"
  // (eliminado). REGLA DURA: solo se antepone/retira la LETRA del tipo; el
  // número NUNCA se rellena. `permitirRecorte` limita la longitud MIENTRAS SE
  // ESCRIBE (comportamiento histórico del input); al reconformar por cambio de
  // tipo se llama con false para no perder dígitos ya escritos.
  //   es_rif=false (V Persona Natural) -> solo dígitos, sin letra.
  //   P (Pasaporte)                    -> 'P-' + cuerpo ALFANUMÉRICO libre.
  //   resto es_rif=true (V-Firma/J/E/G/C) -> letra del tipo + 8 dígitos + control.
  //   sin tipo elegido                 -> formato genérico (histórico).
  const formatearRifPorTipo = (valorCrudo, tipoSel, permitirRecorte = true) => {
    let value = String(valorCrudo || '').toUpperCase().replace(/[^A-Z0-9-]/g, "");
    if (value === '') return '';

    // (a) es_rif=false: cédula, SOLO dígitos y sin letra.
    if (tipoSel && tipoSel.es_rif === false) {
      const d = value.replace(/\D/g, "");
      return permitirRecorte ? d.slice(0, 8) : d;
    }

    const letra = tipoSel ? String(tipoSel.codigo || '').toUpperCase() : null;

    // (b) Pasaporte: cuerpo alfanumérico libre; solo se garantiza el prefijo.
    if (letra === 'P') {
      let cuerpo = value.startsWith('P-') ? value.slice(2)
                 : (value.charAt(0) === 'P' ? value.slice(1) : value);
      cuerpo = cuerpo.replace(/^-+/, '');
      const armado = `P-${cuerpo}`;
      return permitirRecorte ? armado.slice(0, 22) : armado;
    }

    // (c) es_rif=true: la letra la impone el TIPO; el usuario solo escribe dígitos.
    if (letra) {
      let digitos = value.replace(/\D/g, "");
      if (permitirRecorte) digitos = digitos.slice(0, 9);
      if (digitos === '') return `${letra}-`;
      const cuerpo = digitos.slice(0, 8);
      const control = digitos.slice(8);
      return `${letra}-${cuerpo}${control ? '-' + control : (cuerpo.length === 8 ? '-' : '')}`;
    }

    // (d) Sin tipo elegido: formato genérico histórico (letra escrita + dígitos,
    //     o solo dígitos para cédula). Al elegir el tipo se reconforma.
    //     (2026-08-03, T1) 'C' SÍ se admite aquí: `utils.validar_rif` incluye la
    //     letra en su clase (utils.py:351) y el usuario decidió que el RIF
    //     comunal vale también para clientes finales.
    const digitos = value.replace(/\D/g, "");
    if (/^[VJEPGC]/.test(value)) {
      const l = value.charAt(0);
      const d = permitirRecorte ? digitos.slice(0, 9) : digitos;
      if (d === '') return `${l}-`;
      const cuerpo = d.slice(0, 8);
      const control = d.slice(8);
      return `${l}-${cuerpo}${control ? '-' + control : (cuerpo.length === 8 ? '-' : '')}`;
    }
    return permitirRecorte ? digitos.slice(0, 8) : digitos;
  };

  const reduceRif = (rif) => {
    setClient((prev) => ({
      ...prev,
      rif: rif || '',
    }));
  };

  return (
    <div className="mx-auto w-full">
      <ToastContainer />
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12">
          <div className="relative bg-white flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0">
            {/* Header */}
            <div class="rounded-t bg-white mb-0 px-6 py-6">
              <div class="text-center flex justify-between">
                <h6 class="text-blueGray-700 text-xl font-bold">{client.id == '#'? "Crear" : "Actualizar"} Cliente</h6>
              </div>
            </div>
            <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
              <h6 class="text-blueGray-400 text-sm mt-3 my-6 font-bold uppercase">Información del cliente</h6>
              <form onSubmit={handleSubmit} onKeyDown={preventEnterSubmit}>
                <hr class="my-6 border-b-1 border-blueGray-300"/>
                <div className="flex flex-wrap">
                  {/* (ítem 28-i, 2026-08-02) El TIPO DE IDENTIFICACIÓN va
                      ANTES del R.I.F.: es el campo que gobierna el
                      comportamiento del R.I.F. (letra automática vs solo
                      dígitos) — pedirlo después era pedirle al usuario que
                      escribiera el documento a ciegas. Catálogo 7, con las DOS
                      filas 'V' distinguibles. Se envía tipo_identificacion_id
                      (id de la fila elegida). */}
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Tipo de identificación</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client._tipoIdentIdx != null ? client._tipoIdentIdx : ''}
                        onChange={(e) => {
                          const idx = e.target.value === '' ? null : Number(e.target.value);
                          const sel = idx != null ? tiposIdentificacion[idx] : null;
                          setClient({
                            ...client,
                            _tipoIdentIdx: idx,
                            // Espejo del envío: si la fila tiene id, se fija el FK;
                            // si no, se limpia (el backend resolverá por longitud).
                            tipo_identificacion_id: sel && sel.id != null ? sel.id : null,
                            // (ítem 28-ii) Al elegir el tipo se reconforma el
                            // R.I.F.: se antepone/quita SOLO la letra. Se llama
                            // con permitirRecorte=false para NO perder dígitos ya
                            // escritos (la longitud la denuncia validate(), no se
                            // corrige en silencio).
                            rif: formatearRifPorTipo(client.rif, sel, false),
                          });
                        }}
                      >
                        <option value="">Seleccione...</option>
                        {tiposIdentificacion.map((t, idx) => (
                          <option key={`${t.codigo}-${t.id != null ? t.id : 'x'}-${idx}`} value={idx}>
                            {t.label}
                          </option>
                        ))}
                      </select>
                      {errors.tipo_identificacion_id && <p className="text-red-500 text-xs mt-1">{errors.tipo_identificacion_id}</p>}
                      <p className="text-xs text-blueGray-400 mt-1">
                        Persona natural: 6-8 dígitos, sin letra. Firma personal y J/E/G/C: 9 dígitos con la letra.
                      </p>
                      {/* (ítem 28-iii) Degradación VISIBLE del catálogo: jamás en silencio. */}
                      {catalogoAviso && (
                        <p className="text-xs text-amber-600 mt-1">
                          <i className="fas fa-triangle-exclamation mr-1" />
                          {catalogoAviso}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="w-full lg:w-3/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">RIF</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.rif}
                        placeholder={(() => {
                          const t = getTipoIdentSeleccionado();
                          if (!t) return "V-12345678-0";
                          if (t.es_rif === false) return "12345678";
                          if (String(t.codigo).toUpperCase() === 'P') return "P-AB123456";
                          return `${t.codigo}-12345678-0`;
                        })()}
                        onChange={(e) => {
                          // (ítem 28-ii) La conformación la decide el TIPO
                          // seleccionado (es_rif), no un radio de "Tipo de cliente".
                          const value = formatearRifPorTipo(e.target.value, getTipoIdentSeleccionado(), true);
                          setClient({ ...client, rif: value });
                        }}
                        onKeyDown={(e) => {
                          // Si el usuario presiona Backspace
                          if (e.key === "Backspace") {
                            if (client.rif && client.rif.substr(client.rif.length - 1, client.rif.length) == '-'){
                              reduceRif(client.rif.substr(0, client.rif.length - 1));
                            }
                          }
                        }}
                      />
                      {errors.rif && <p className="text-red-500 text-xs mt-1">{errors.rif}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Razón social</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.nombre}
                        placeholder="Nombre de la empresa"
                        onChange={(e) => setClient({ ...client, nombre: e.target.value.toUpperCase() })}
                      />
                      {errors.nombre && <p className="text-red-500 text-xs mt-1">{errors.nombre}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Denominación comercial</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.denominacion_comercial}
                        placeholder="Denominación comercial"
                        onChange={(e) => setClient({ ...client, denominacion_comercial: e.target.value.toUpperCase() })}
                      />
                      {errors.denominacion_comercial && <p className="text-red-500 text-xs mt-1">{errors.denominacion_comercial}</p>}
                      </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Teléfono</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.telefono}
                        placeholder="0000-0000000"
                        onChange={(e) => {
                          let value = e.target.value;
                          // Eliminar todo lo que no sea número
                          value = value.replace(/\D/g, "");

                          // Limitar a máximo 11 dígitos (4 + 7)
                          value = value.slice(0, 11);

                          // Insertar guion después de los primeros 4 dígitos
                          if (value.length > 4) {
                            value = value.slice(0, 4) + "-" + value.slice(4);
                          }
                          setClient({ ...client, telefono: value });
                        }}
                      />
                      {errors.telefono && <p className="text-red-500 text-xs mt-1">{errors.telefono}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-5/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Correo electrónico</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.email}
                        placeholder="correo@correo.com"
                        onChange={(e) => setClient({ ...client, email: e.target.value.toUpperCase() })}
                      />
                      {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-12/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Dirección</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.direccion}
                        placeholder="Calle, Avenida, Torre y/o Edificio"
                        onChange={(e) => setClient({ ...client, direccion: e.target.value.toUpperCase() })}
                      />
                      {errors.direccion && <p className="text-red-500 text-xs mt-1">{errors.direccion}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Región</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.region} onChange={(e) => {
                          const selectedOption = e.target.options[e.target.selectedIndex];
                          const regionId = selectedOption.getAttribute("region_id"); // obtienes el atributo
                          const regionValue = e.target.value; // obtienes el value normal
                          console.log("region_id:", regionId);
                          console.log("region value:", regionValue);
                          $('.region_id').addClass('hidden');
                          if (regionId){
                            $('.region_' + regionId.toString()).removeClass('hidden');
                          }
                          client.estado = '#';
                          // actualizamos el estado con ambos si quieres
                          setClient({ ...client, region: e.target.value });
                        }}>
                        <option value="#">Seleccione...</option>
                        <option region_id="1" value="Central">Central</option>
                        <option region_id="2" value="Capital">Capital</option>
                        <option region_id="3" value="Occidental">Occidental</option>
                        <option region_id="4" value="Guayana">Guayana</option>
                        <option region_id="5" value="Insular">Insular</option>
                        <option region_id="6" value="Los Andes">Los Andes</option>
                        <option region_id="7" value="Los Llanos">Los Llanos</option>
                        <option region_id="8" value="Oriental">Oriental</option>
                        <option region_id="9" value="Zuliana">Zuliana</option>
                      </select>
                      {errors.region && <p className="text-red-500 text-xs mt-1">{errors.region}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Estado</label>
                      <select id="select_state"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.estado} onChange={(e) => setClient({ ...client, estado: e.target.value })}>
                        <option value="#">Seleccione...</option>
                        <option class="region_id region_1" value="Aragua">Aragua</option>
                        <option class="region_id region_1" value="Carabobo">Carabobo</option>
                        <option class="region_id region_1" value="Cojedes">Cojedes</option>
                        <option class="region_id region_2" value="Distrito Capital">Distrito Capital</option>
                        <option class="region_id region_2" value="Miranda">Miranda</option>
                        <option class="region_id region_2" value="La Guaira">La Guaira</option>
                        <option class="region_id region_3" value="Falcón">Falcón</option>
                        <option class="region_id region_3" value="Lara">Lara</option>
                        <option class="region_id region_3" value="Portuguesa">Portuguesa</option>
                        <option class="region_id region_3" value="Yaracuy">Yaracuy</option>
                        <option class="region_id region_4" value="Amazonas">Amazonas</option>
                        <option class="region_id region_4" value="Bolívar">Bolívar</option>
                        <option class="region_id region_4" value="Delta Amacuro">Delta Amacuro</option>
                        <option class="region_id region_4" value="Guayana Esequiba">Guayana Esequiba</option>
                        <option class="region_id region_5" value="Dependencias Federales">Dependencias Federales</option>
                        <option class="region_id region_5" value="Nueva Esparta">Nueva Esparta</option>
                        <option class="region_id region_6" value="Barinas">Barinas</option>
                        <option class="region_id region_6" value="Mérida">Mérida</option>
                        <option class="region_id region_6" value="Táchira">Táchira</option>
                        <option class="region_id region_6" value="Trujillo">Trujillo</option>
                        <option class="region_id region_6" value="Apure - Municipio Páez">Apure - Municipio Páez</option>
                        <option class="region_id region_7" value="Apure - Sin el Municipio Páez">Apure - Sin el Municipio Páez</option>
                        <option class="region_id region_7" value="Guárico">Guárico</option>
                        <option class="region_id region_8" value="Anzoátegui">Anzoátegui</option>
                        <option class="region_id region_8" value="Monagas">Monagas</option>
                        <option class="region_id region_8" value="Sucre">Sucre</option>
                        <option class="region_id region_9" value="Zulia">Zulia</option>
                      </select>
                      {errors.estado && <p className="text-red-500 text-xs mt-1">{errors.estado}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-6/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Zona</label>
                      <input
                        type="text"
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.zona}
                        onChange={(e) => setClient({ ...client, zona: e.target.value.toUpperCase() })}
                      />
                      {errors.zona && <p className="text-red-500 text-xs mt-1">{errors.zona}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-2">Tipo de contribuyente</label>
                      <select
                        className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                        value={client.tipo_contribuyente_id}
                        onChange={(e) => setClient({ ...client, tipo_contribuyente_id: e.target.value })}
                      >
                        <option value="0">Seleccione...</option>
                        {typeTaxpayer.length > 0 ? (
                            typeTaxpayer.map(taxpayer => (
                            <option key={taxpayer.id} value={taxpayer.id}>{taxpayer.nombre}</option>
                          ))
                        ) : (
                          <option value="0">Seleccione...</option>
                        )}
                      </select>
                      {errors.tipo_contribuyente_id && <p className="text-red-500 text-xs mt-1">{errors.tipo_contribuyente_id}</p>}
                    </div>
                  </div>
                  <div className="w-full lg:w-2/12 px-4">
                    <div className="relative w-full mb-3">
                      <label className="block text-blueGray-600 text-xs font-bold mb-4">Condición</label>
                      {(client.activo == true) ? (
                        <label class="bg-emerald-400 text-white py-1 px-3 rounded-full text-center">Activo</label>
                      ):(
                        <label class="bg-red-400 text-white py-1 px-3 rounded-full text-center">Inactivo</label>
                      )}
                    </div>
                  </div>
                </div>
                <div className={FORM_FOOTER_CONTAINER}>
                  <button
                    type="button"
                    className={FORM_BTN_CANCEL}
                    disabled={buttonDisabled}
                    onClick={() => redirectToList()}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className={FORM_BTN_SUBMIT}
                    disabled={buttonDisabled}
                  >
                    {buttonDisabled
                      ? (client.id == '#' ? "Guardando..." : "Actualizando...")
                      : (client.id == '#' ? "Guardar" : "Actualizar")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FormEndClients;